<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/clean-step5')"></span>
    </div>
    <div class="title">额外项目资费标准</div>
    <div class="subtitle">下列清洁项目需要额外收费<br>服务人员根据现场卫生情况与您当面协商</div>
    <div class="core">
      <div class="item">
        <div class="item-head" @click ="item1 = !item1">
          <span class="itemtext">地毯清洁</span>
          <span class="icon-chevron-down"  v-show="!item1"></span>
          <span class="icon-chevron-up"  v-show="item1"></span>
        </div>

        <div class="item-detail" v-show="item1">
          <div class="detail clearfix">
            <span class="pull-left">洗地毯1房</span>
            <span class="pull-right">$70</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">洗地毯2房</span>
            <span class="pull-right">$80</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">洗地毯3房</span>
            <span class="pull-right">$90</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">洗地毯4房</span>
            <span class="pull-right">$120</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">洗地毯5房</span>
            <span class="pull-right">$150</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">楼梯洗地毯</span>
            <span class="pull-right">$30 / 层</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">地毯机楼层搬运（电梯楼免费）</span>
            <span class="pull-right">$20 / 层</span>
          </div>
        </div>
      </div>

      <div class="item">
        <div class="item-head" @click ="item2 = !item2">
          <span class="itemtext">门窗深度清洁</span>
          <span class="icon-chevron-down"  v-show="!item2"></span>
          <span class="icon-chevron-up"  v-show="item2"></span>
        </div>

        <div class="item-detail" v-show="item2">
          <div class="detail clearfix">
            <span class="pull-left">落地拉门超过4扇</span>
            <span class="pull-right">$15 / 扇</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">窗户玻璃超过5扇</span>
            <span class="pull-right">$5 / 扇</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">百叶窗清洁只弹灰尘</span>
            <span class="pull-right">免费</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">深度清理百叶窗</span>
            <span class="pull-right">$20 - $50 / 组</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">纱窗</span>
            <span class="pull-right">$15 / 扇</span>
          </div>
        </div>
      </div>


      <div class="item">
        <div class="item-head" @click ="item3 = !item3">
          <span class="itemtext">厨房深度清洁</span>
          <span class="icon-chevron-down"  v-show="!item3"></span>
          <span class="icon-chevron-up"  v-show="item3"></span>
        </div>

        <div class="item-detail" v-show="item3">
          <div class="detail clearfix">
            <span class="pull-left">微波炉</span>
            <span class="pull-right">$10 - $20</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">冰箱</span>
            <span class="pull-right">$20 - $50</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">洗碗机</span>
            <span class="pull-right">$30</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">厨房油渍太重</span>
            <span class="pull-right">$30 - $50</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">烤箱重度清洁</span>
            <span class="pull-right">$30 - $50</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">油烟机重度清洁</span>
            <span class="pull-right">$30 - $50</span>
          </div>

        </div>
      </div>


      <div class="item">
        <div class="item-head" @click ="item4 = !item4">
          <span class="itemtext">其他清洁</span>
          <span class="icon-chevron-down"  v-show="!item4"></span>
          <span class="icon-chevron-up"  v-show="item4"></span>
        </div>

        <div class="item-detail" v-show="item4">
          <div class="detail clearfix">
            <span class="pull-left">墙面可擦洗污渍清洁</span>
            <span class="pull-right">$15 / ㎡</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">墙面发霉</span>
            <span class="pull-right">$15 / ㎡</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">阳台清洁</span>
            <span class="pull-right">$10 - $50</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">生活垃圾清洁</span>
            <span class="pull-right">$30起</span>
          </div>
          <div class="detail clearfix">
            <span class="pull-left">宠物清洁</span>
            <span class="pull-right">现场评估</span>
          </div>
        </div>
      </div>

    </div>

    <div class="btn-box-fix">
      <div class="btn-container">

        <router-link to="/clean-step7"  class="btn active" >
		      下一步
        </router-link>
      </div>
    </div>
    <img :src="pixelURL('clean','ewaishoufei')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'clean-step6',
  data () {
    return {
      order:{},
      item1:true,
      item2:true,
      item3:true,
      item4:true,
    }
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "clean"){
        this.order = localParsed;
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.title{
  padding-bottom:4px;
}

.detail{
  padding:1px 4px;
  font-size:0.8em;
  color:#777;
}

.core{
  padding:40px;
  padding-top:10px;
}

.subtitle{
  text-align:center;
  font-size:0.9em;
  color:#888;
}

.item-detail{
  margin-top:8px;
}

.item{
  font-size:1.2em;
  padding:12px 0;
  border-bottom:1px solid #eee;
  .icon-chevron-down{
    float:right;
    line-height:1.6em;
  }
  .icon-chevron-up{
    float:right;
    line-height:1.6em;
  }
}

.btn{
	width:300px;
	height: 50px;
	cursor: pointer;
	background: #ddd;
	color:#666;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50px;
	font-size: 1.2em;
    font-weight: 100;
    margin: 0 auto;
    margin-top: 12px;
    max-width:100%;
}

.btn-box{
    background:rgba(255,255,255,1);
    box-shadow: -1px -1px 8px rgba(40,40,40,0.1);
    border-top:1px solid #eee;
    position: fixed;
    bottom: 0px;
    padding-bottom:15px;
    text-align:center;
    width:100%;
    box-sizing:border-box;
    z-index:99;
}
.btn.active{
    color:#fff;
	background: rgb(237,121,75);
	background: linear-gradient(90deg, #ff7444 0%,#fe9567 100%);
	-webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
	-moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
    box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
}

.btn:active{
	background: linear-gradient(90deg, #ff7444 0%,#fe9567 50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/clean/step6.vue